import React from 'react';
import { Form } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import LBOffCanvas from '../UI/LBOffCanvas';

function ChangePasswordRequest() {
  return (
    <LBOffCanvas.Left>
      <LBOffCanvas.Header>Change password</LBOffCanvas.Header>

      <h6 className="mb-3">Send verification e-mail</h6>
      <p className="mb-4">
        Before we can reset your password we need to verify your identity. Check
        your e-mail in the following minutes for a e-mail containing the link to
        continue the password change processs
      </p>
      <Form method="post">
        <Button type="submit">Send e-mail</Button>
      </Form>
    </LBOffCanvas.Left>
  );
}

export default ChangePasswordRequest;
